import React from 'react';
import DefaultLayout from '../layouts/default';
import Group from '../components/group-modal/group';

export default function group() {
  return (
    <div>
      <DefaultLayout>
        <Group />
      </DefaultLayout>
    </div>
  );
}
